import { FesNotification } from '../../../../brokers/fes-notification.model';
import { AppDeleteTitles } from './app-delete.titles';

export const appDeleteError = (): FesNotification =>
  new FesNotification(AppDeleteTitles.error);

export const appDeleteSuccess = (): FesNotification =>
  new FesNotification(AppDeleteTitles.success);
